<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-tab-section-bottom panel-bottom-flex">
    <div v-if="!controller.loading" class="chart-legend">
      <div class="legend-flex" @click="toggleLegend(item)" v-for="(item, index) in legendsData" :key="index">
        <!-- <div v-if="item.legend=='average conversations'||item.legend=='agent wait time'" class="line-marker" :style="{'background-color': item.color}"></div> -->
        <div v-if="isLineLegend(index)" class="line-marker regression-marker" :class="(!item.toggle?'grey-out':'')" 
          :style="{'background-color': item.color}">
        </div>
        <div v-else :class="{'regression-marker': item.legend == 'regression', 'legend-marker': item.legend != 'regression', 'grey-out':!item.toggle}" 
          :style="item.legend == 'regression' && legendsData.length == 2?{'background-color': 'none'}:{'background-color': item.color}">
        </div>
        <div class="legend-name" :class="(!item.toggle?'grey-out':'')" >{{item.legend}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    name: 'wy-panel-tab-section-bottom',
    props: ['controller', 'legendData', 'sectionData', 'parent'],
    data() {
      return {
        // legendColor:['#6567CA', '#8A8EF4', '#4D50E8', '#382373', '#231351','#0C2837', 'var(--site-font-tertiary-color)'],  
        legendsData: []
      }
    },
    computed: {
    ...mapGetters(['legendColors']),
    },
    methods: {
      isLineLegend(index){
        // multiChart
        if(this.controller.sectionData.multiChart && index == this.legendsData.length - 1) {
          return true;
        }
        else {
          return false
        }
      },

      renderLegends() {
        this.legendsData = [];
        // console.log(this.sectionData, this.legendData)
        if(this.sectionData.lineChartData && !this.sectionData.columnChartData) {
          // let legendColors = ["#1C4DB2", "#000"]
          this.legendData['legends'].forEach((item, index) => {
            let obj = {};
            obj.legend = item;
            obj.toggle = true;
            obj.color = this.sectionData.lineChartData.legendColors[index];
            // if(item == 'average conversations' || item == 'agent wait time') {
            //   obj.color = '#000';
            // }
            this.legendsData.push(obj);
          });
        }
        else {
          if(this.sectionData.pieChartData) {
            this.legendData['legends'].forEach((item, index) => {
              let obj = {};
              obj.legend = item;
              obj.toggle = true;
              obj.color = this.sectionData.pieChartData.legendColors[index];
              if(this.sectionData && this.sectionData.multiChart && index == (this.legendData['legends'].length - 1)) {
                obj.comboLine = true;
                obj.color = '#0C2837';
              }
              this.legendsData.push(obj);
            });
          }
        }
        let obj = {};
        obj.legend = 'regression';
        obj.color = '0C2837';
        obj.toggle = true;
        this.legendsData.push(obj);
      },
      toggleLegend(item) {
        // console.log((!this.sectionData.multiChart && this.sectionData.lineChartData))
        // if(this.sectionData && !this.sectionData.multiChart && this.sectionData.lineChartData) {
        if(this.sectionData) { 
          // line chart
          if(this.parent.$refs.lineChart) {
            let toggleCount = 0;
            this.legendsData.forEach((legend, index) => {
              if(index < this.legendsData.length - 1) {
                if(legend.toggle) {
                  toggleCount = toggleCount + 1
                }
              }
            })
            if(item.legend == 'regression' || toggleCount > 1 || !item.toggle) {
              item.toggle = !item.toggle;
              this.parent.$refs.lineChart.toggleLegend(item.legend, item.toggle)
            }
          }
          if(this.parent.$refs.columnChart) {
            let toggleCount = 0;
            this.legendsData.forEach((legend, index) => {
              if(index < this.legendsData.length - 1) {
                if(legend.toggle && !legend.regressionLine) {
                  toggleCount = toggleCount + 1
                }
              }
            })
            if(item.legend == 'regression' || toggleCount > 1 || !item.toggle) {
              item.toggle = !item.toggle;
              this.parent.$refs.columnChart.toggleLegend(this.legendsData)
              if(item.legend != 'regression') {
                // this.parent.$refs.pieChart.toggleLegend(this.legendsData)
              }
            }
          }
          if(this.parent.$refs.comboChart) {
            let toggleCount = 0;
            this.legendsData.forEach((legend, index) => {
              if(index < this.legendsData.length - 1) {
                if(legend.toggle && !legend.comboLine && !legend.regressionLine) {
                  toggleCount = toggleCount + 1
                }
              }
            })
            if(item.legend == 'regression' || item.comboLine || toggleCount > 1 || !item.toggle) {
              item.toggle = !item.toggle;
              this.parent.$refs.comboChart.toggleLegend(this.legendsData)
              if(item.legend != 'regression') {
                // this.parent.$refs.pieChart.toggleLegend(this.legendsData)
              }
            }
            // item.toggle = !item.toggle;
            // this.parent.$refs.comboChart.toggleLegend(this.legendsData, item.toggle)
          }
          // if(this.parent.$refs.pieChart) {
          //   let toggleCount = 0;
          //   this.legendsData.forEach((legend, index) => {
          //     if(index < this.legendsData.length - 1) {
          //       if(legend.toggle) {
          //         toggleCount = toggleCount + 1
          //       }
          //     }
          //   })
          //   if(toggleCount > 1 || !item.toggle) {
          //     item.toggle = !item.toggle;
          //     this.parent.$refs.pieChart.toggleLegend(this.legendsData, item.toggle)
          //   }
          // }
          
        }
      }
    },
    mounted() {
      // this.renderLegends()
    }
  }); 
</script>

<style lang="scss">
  .wy-panel-tab-section-bottom.panel-bottom-flex {
    border-top: 1px #CAD2DA solid;
    // height: 125px;
    height: 75px;
    display: flex;
    align-items: center;
    align-items: center;
    margin-bottom: 2px;

    .legend-marker {
      cursor: pointer;
      border-radius: 50%;
      width: 10px;
      height: 10px;
    }
    .regression-marker{
      cursor: pointer;
      margin:5px 5px;
      height:2px;
      width: 25px;
      background-color: unset !important;
      background:repeating-linear-gradient(to right,black 0,black 5px,transparent 5px,transparent 7px)
    }
    .line-marker{
      cursor: pointer;
      margin:5px 5px;
      position: relative;
      top: 1px;
      height:2px;
      width: 25px;
    }
    .chart-legend{
      display: flex;
      width: 89%;
      height: 50px;
      overflow-y: hidden;
      position: relative;
      left: 38px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }
    .legend-flex {
      display: flex;
      height: 25px;
      -webkit-box-align: center;
      align-items: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .legend-marker {
      margin: 5px;
    }
    .legend-marker.grey-out {
      opacity: 0.3;
    }
    .regression-marker.grey-out {
      opacity: 0.3;
    }
    .legend-name {
      cursor: pointer;
      font-size: 14.22px;
      color: var(--site-font-tertiary-color);
      font-weight:400;
      line-height: 1;
    }
    .legend-name.grey-out {
      color: #CCC;
    }
  }
</style>
